import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-xl p-6 md:p-12 border-2 border-green-200" data-id="element-130">
          <div className="flex flex-col items-center text-center" data-id="element-131">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-green-100 rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-132">
              <Shield className="w-8 h-8 md:w-10 md:h-10 text-green-600" data-id="element-133" />
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-4 md:mb-6" data-id="element-134">
              🛡️ Gwarancja zwrotu pieniędzy 100% w ciągu 7 dni
            </h2>

            <div className="space-y-3 md:space-y-4 text-base md:text-lg text-gray-700 max-w-2xl" data-id="element-135">
              <p data-id="element-136">Pobierz wszystko. Przeczytaj wszystko.</p>
              <p data-id="element-137">Zastosuj na swoim treningu.</p>
              <p className="font-bold text-navy-primary text-lg md:text-xl mt-2" data-id="element-138">
                Jeśli nie jesteś w 100% zadowolony w ciągu 7 dni
                <br data-id="element-139" />
                zwracamy całą kwotę.
              </p>
              <p className="text-sm md:text-base text-gray-600 mt-4 md:mt-6" data-id="element-140">
                Bez pytań. Bez skomplikowanych procedur.
                <br data-id="element-141" />
                Całe ryzyko bierzemy na siebie.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}